module.exports = __webpack_public_path__ + "img/13.8c326c06.jpg";